import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  Form,
  LoadPanel,
  Popup,
  RequiredRule,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
} from "devextreme-react/data-grid";
import { Label, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

export default function Awards() {
  const [dataSource, setDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  const awardsGridRef = useRef(null);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/awards/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/awards/${userInfo.employeeNo}`,
            values
          );
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/awards/${userInfo.employeeNo}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/awards/${userInfo.employeeNo}/${key}`
          );
        },
      })
    );
  }, []);

  const onInitNewRow = (e) => {
    const key = awardsGridRef.current.instance.getKeyByRowIndex(0);

    if (key) {
      e.component.selectRows(key, true);
      e.data = awardsGridRef.current.instance.getSelectedRowsData()[0];
    }
  };

  return (
    <DataGrid
      id="awardsGrid"
      ref={awardsGridRef}
      dataSource={dataSource}
      keyExpr="SEQ"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnable={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
        // marginTop: "56px",}
      }}
      hoverStateEnabled={true}
      showColumnHeaders={true}
      onInitNewRow={onInitNewRow}
    >
      <LoadPanel enabled={true} />

      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <Selection mode={"single"} />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteTitle={"Delete the Award"}
          confirmDeleteMessage="Are you sure you want to delete this award?"
        />
        <Popup title={"Award"} showTitle={true} height={"auto"} />
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="awards"
          height={"100%"}
        >
          <SimpleItem
            dataField={"desi"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"명칭"} />
            <RequiredRule message={"* 명칭을 입력해주세요."} />
          </SimpleItem>
          <SimpleItem
            dataField={"mgmt"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"주관"} />
            <RequiredRule message={"* 주관을 입력해주세요."} />
          </SimpleItem>
          <SimpleItem
            dataField={"aDate"}
            editorType="dxDateBox"
            editorOptions={{
              type: "date",
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
            }}
          >
            <Label text={"수상일"} />
            <RequiredRule message={"* 수상일을 입력해주세요."} />
          </SimpleItem>
          <SimpleItem
            dataField={"aHis"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"수상내역"} />
            <RequiredRule message={"* 수상내역을 입력해주세요."} />
          </SimpleItem>
          <SimpleItem
            dataField={"aDetails"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
            colSpan={4}
          >
            <Label text={"상세내용"} />
          </SimpleItem>
        </Form>
      </Editing>

      <Column dataField={"desi"} caption="명칭" />
      <Column dataField={"mgmt"} caption="주관" />
      <Column
        dataField={"aDate"}
        caption="수상일"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
      />
      <Column dataField={"aHis"} caption="수상내역" />
      <Column dataField={"aDetails"} caption="상세내용" />
    </DataGrid>
  );
}
